import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiCurrency } from '@app/packages/api/v2/types/entities'

export class ApiCurrencyFabricator extends ApiFabricator<ApiCurrency> {
  protected getBase = (): ApiCurrency => ({
    type: 'currencies',
    id: ApiFabricator.getId('currencies'),
    attributes: {
      iso_code: 'RUB',
      name: 'Russian ruble',
    },
  })
}
